import React from "react";
// import Switch from "../Switch/Switch";

class RatesDashboardToggles extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="RatesDashboardToggles">
        <label>
          <input
            type="radio"
            name="rates_dashboard_toggle"
            value="prices"
            onChange={this.props.onChangeToggle}
            checked={this.props.toggleSetting === "prices"}
          />{" "}
          {I18n.t("price")}
        </label>
        <br />
        <label>
          <input
            type="radio"
            name="rates_dashboard_toggle"
            value="minimum_stay"
            onChange={this.props.onChangeToggle}
            checked={this.props.toggleSetting === "minimum_stay"}
          />{" "}
          {I18n.t("minimum_stay")}
        </label>
        <br /> 
        <label>
          <input
            type="radio"
            name="rates_dashboard_toggle"
            value="daily_rentals"
            onChange={this.props.onChangeToggle}
            checked={this.props.toggleSetting === "daily_rentals"}
          />{" "}
          {I18n.t("daily_rentals")}
        </label>
      </div>
    );
  }
}

export default RatesDashboardToggles;
